import { useState, useEffect, useRef } from "react";

function useCanvasScreenshot({
  canvasSelector = "canvas",
  interval = 2000,
  active = false,
  quality = 0.5,
  onScreenshot = null
}) {
  const [screenshotUrl, setScreenshotUrl] = useState(null);
  const [isCapturing, setIsCapturing] = useState(active);
  const intervalRef = useRef(null);

  const takeScreenshot = () => {
    try {
      const canvas = document.querySelector(canvasSelector);

      if (canvas && canvas.width > 0 && canvas.height > 0) {
        const dataUrl = canvas.toDataURL(`image/jpeg`, quality);
        setScreenshotUrl(dataUrl);

        if (onScreenshot && typeof onScreenshot === "function") {
          onScreenshot(dataUrl);
        }

        return dataUrl;
      }
      return null;
    } catch (error) {
      console.error("Error taking canvas screenshot:", error);
      return null;
    }
  };

  const startCapture = () => {
    setIsCapturing(true);
  };

  const stopCapture = () => {
    setIsCapturing(false);
  };

  useEffect(() => {
    if (isCapturing) {
      takeScreenshot();

      intervalRef.current = setInterval(takeScreenshot, interval);
    } else if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isCapturing, interval, active]);

  useEffect(() => {
    setIsCapturing(active);
  }, [active]);

  return {
    screenshotUrl,
    isCapturing,
    takeScreenshot,
    startCapture,
    stopCapture
  };
}

export default useCanvasScreenshot;
